/**
 * @description 季报图表趋势组件
 * @date 2025-01-24
 * @author lv.chen
 */
import React from 'react';
import classnames from 'classnames';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import TrendLineChart from '../TrendLineChart';

interface IChartTrendProps extends IBaseProps {
  quarterChars?: string;
  report?: IQuarterReportDetails | null;
  year?: number;
}

/**
 * 季报图表趋势组件
 */
const ChartTrend: React.FC<IChartTrendProps> = (props) => {
  const { style, className, report, quarterChars, year } = props;

  const { formatMessage } = useIntlExtend();

  return (
    <div style={style} className={classnames('chart-trend', className)}>
      <div className="quarter-report-title">
        <span>{formatMessage({ id: 'dbu_quarter_report_activity_trend' }, { quarter: quarterChars })}</span>
      </div>
      <div className="chart-trend-content">
        <div className="chart-trend-chart">
          <TrendLineChart loading={false} trends={report?.trends} height={120} year={year} />
        </div>
        <div className="chart-trend-info">
          <div className="chart-trend-info-card --card01">
            <div className="chart-trend-info-title">
              {formatMessage({ id: 'dbu_quarter_report_used_days' }, { quarter: quarterChars })}
            </div>
            <div className="chart-trend-info-desc">
              <span className="--num">{report?.days_used}</span>
              {formatMessage({ id: 'dbu_common_days' })}
            </div>
          </div>
          <div className="chart-trend-info-card --card02">
            <div className="chart-trend-info-title">
              {formatMessage({ id: 'dbu_quarter_report_total_activity' }, { quarter: quarterChars })}
            </div>
            <div className="chart-trend-info-desc">
              <span className="--num">{report?.total_activity}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartTrend;
